/**
 * Tailwind-aware class merger.
 *
 * Combines `clsx` (conditional class strings) with `tailwind-merge`
 * (de-duplicates conflicting Tailwind utilities so the last one wins).
 *
 * Use this everywhere a component composes class names — never `${...}` in
 * a template, because Tailwind classes need conflict resolution
 * (`p-4` + `p-2` from a variant should yield `p-2`).
 */
import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
